import { Tooltip, Toast, Popover, Collapse } from 'bootstrap';
import './member-teaser.js';

[].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]')).map(function (tooltipTriggerEl) {
    return new Tooltip(tooltipTriggerEl);
});

[].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]')).map(function (popoverTriggerEl) {
    return new Popover(popoverTriggerEl);
});

[].slice.call(document.querySelectorAll('.toast')).map(function (toastEl) {
  return new Toast(toastEl);
});

/**
 * Collapse toggles for the mobile header (#27161).
 *
 * These are wired from JS instead of data-bs-toggle on purpose. Two copies of
 * Bootstrap load on this site (5.0.2 globally via functions.php and 5.2.3
 * bundled through this file), so both register the collapse data-api and a
 * single click gets handled twice. The two instances desync and the panel can
 * no longer be closed. Owning a single instance per panel sidesteps that.
 *
 * Note the `collapsed` class is maintained by hand here, because the data-api
 * is what used to manage it and .navbar-toggler styling depends on it.
 */
function wireCollapseToggle( toggleEl, panelEl, onShown ) {
	if ( ! toggleEl || ! panelEl ) {
		return;
	}

	var collapse = Collapse.getOrCreateInstance( panelEl, { toggle: false } );

	toggleEl.addEventListener( 'click', function ( event ) {
		event.preventDefault();
		collapse.toggle();
	} );

	panelEl.addEventListener( 'show.bs.collapse', function () {
		toggleEl.setAttribute( 'aria-expanded', 'true' );
		toggleEl.classList.remove( 'collapsed' );
	} );

	panelEl.addEventListener( 'hide.bs.collapse', function () {
		toggleEl.setAttribute( 'aria-expanded', 'false' );
		toggleEl.classList.add( 'collapsed' );
	} );

	panelEl.addEventListener( 'keydown', function ( event ) {
		if ( 'Escape' === event.key ) {
			collapse.hide();
			toggleEl.focus();
		}
	} );

	if ( onShown ) {
		panelEl.addEventListener( 'shown.bs.collapse', onShown );
	}
}

document.addEventListener( 'DOMContentLoaded', function () {
	var searchInput = document.getElementById( 'mobile-search-input' );

	var searchPanel = document.getElementById( 'mobileSearch' );

	wireCollapseToggle(
		document.querySelector( '.btn-search-toggle' ),
		searchPanel,
		function () {
			if ( searchInput ) {
				searchInput.focus();
			}
		}
	);

	// Banner pages float a transparent header over the hero, so an open search
	// panel reads as a white band cut across the photo. Flip the header to the
	// solid treatment the search results page uses while the panel is open.
	// Only .main-header exists on banner pages; elsewhere the header is already
	// solid and this is a no-op.
	var bannerHeader = document.querySelector( '.main-header' );

	if ( bannerHeader && searchPanel ) {
		searchPanel.addEventListener( 'show.bs.collapse', function () {
			bannerHeader.classList.add( 'search-open' );
		} );

		searchPanel.addEventListener( 'hide.bs.collapse', function () {
			bannerHeader.classList.remove( 'search-open' );
		} );
	}

	var navPanel  = document.getElementById( 'mobilenav' );
	var navToggle = document.querySelector( '.mobile-nav .navbar-toggler' );

	// The menu's height was hardcoded in CSS, so it overflowed short viewports
	// and left dead space on tall ones. Measure the room actually left below it.
	function fitNavToViewport() {
		if ( ! navPanel || ! navPanel.classList.contains( 'show' ) ) {
			return;
		}

		var top = navPanel.getBoundingClientRect().top;
		navPanel.style.maxHeight = Math.max( 200, window.innerHeight - top ) + 'px';
	}

	wireCollapseToggle( navToggle, navPanel, fitNavToViewport );

	if ( navPanel ) {
		// Stop the page behind the open menu from scrolling.
		navPanel.addEventListener( 'show.bs.collapse', function () {
			document.body.classList.add( 'mobile-nav-open' );
		} );

		navPanel.addEventListener( 'hidden.bs.collapse', function () {
			document.body.classList.remove( 'mobile-nav-open' );
			navPanel.style.maxHeight = '';
		} );

		window.addEventListener( 'resize', fitNavToViewport );
		window.addEventListener( 'orientationchange', fitNavToViewport );
	}
} );

/* global wp, jQuery */
/**
 * File customizer.js.
 *
 * Theme Customizer enhancements for a better user experience.
 *
 * Contains handlers to make Theme Customizer preview reload changes asynchronously.
 */

( function( $ ) {
	if (document.readyState === "complete") {
		// Fully loaded!
		// console.log('Loaded');
	  }
	window.addEventListener("load", () => {
		// Fully loaded!
		// console.log('Loaded');
		//Grab title for image rollover
	  });
	// #27161: wp.customize only exists inside the Customizer preview. On the front
	// end `wp` is undefined, so this threw and killed every statement below it.
	if ( typeof wp !== 'undefined' && typeof wp.customize !== 'undefined' ) {
		// Site title and description.
		wp.customize( 'blogname', function( value ) {
			value.bind( function( to ) {
				$( '.site-title a' ).text( to );
			} );
		} );
		wp.customize( 'blogdescription', function( value ) {
			value.bind( function( to ) {
				$( '.site-description' ).text( to );
			} );
		} );

		// Header text color.
		wp.customize( 'header_textcolor', function( value ) {
			value.bind( function( to ) {
				if ( 'blank' === to ) {
					$( '.site-title, .site-description' ).css( {
						clip: 'rect(1px, 1px, 1px, 1px)',
						position: 'absolute',
					} );
				} else {
					$( '.site-title, .site-description' ).css( {
						clip: 'auto',
						position: 'relative',
					} );
					$( '.site-title a, .site-description' ).css( {
						color: to,
					} );
				}
			} );
		} );
	}
	function getJoinData() {
		var values = $('#input_3_7').val() + ' ' +
					 $('#input_3_42').val() + ' ' +
					 $('#input_3_9').val() + ' ' +
					 $('#input_3_10').val() + ' ' +
					 $('#input_3_11').val() + ' ' +
					 $('#input_3_13').val() + ' ' +
					 $('#input_3_14').val() + ' ' +
					 $('#input_3_15').val() + ' ' +
					 $('#input_3_18').val() + ' ' +
					 $('#input_3_19').val() + ' ' +
					 $('#input_3_20').val() + ' ' +
					 $('#input_3_21').val() + ' ' +
					 $('#input_3_22').val() + ' ' +
					 $('#input_3_48').val() + ' ' +
					 $('#input_3_23').val() + ' ' +
					 $('#input_3_26').val() + ' ' +
					 $('#input_3_27').val() + ' ' +
					 $('#input_3_30').val() + ' ' +
					 $('#input_3_31').val() + ' ' +
					 $('#input_3_32').val() + ' ' +
					 $('#input_3_34').val();
		$('#joining-details').text(values);
	  }

	$('#gform_next_button_3_3').on('click', function(event) {
		alert('cloickedd');
		event.preventDefault();
		getJoinData();
	});

	
	// $( "#gform_next_button_3_3" ).click(function() {
	// // Form data in join us
	// 	$('#input_3_7').val()  // i am a 
	// 	$('#input_3_42').val() // located in
	// 	$('#input_3_9').val()  // employed
	// 	$('#input_3_10').val() // fulltime
	// 	$('#input_3_11').val() // salary
	// 	$('#input_3_13').val() // workplace
	// 	$('#input_3_14').val() // nesa Yes
	// 	$('#input_3_15').val() // first year teaching? yes 
	// 	$('#input_3_18').val() // surname 
	// 	$('#input_3_19').val() // firstnmae 
	// 	$('#input_3_20').val() // mid name 
	// 	$('#input_3_21').val() // dob
	// 	$('#input_3_22').val() // gender
	// 	$('#input_3_48').val() // postal
	// 	$('#input_3_23').val() // suburb
	// 	$('#input_3_26').val() // state
	// 	$('#input_3_27').val() // postcode
	// 	$('#input_3_30').val() // phone
	// 	$('#input_3_31').val() // mobile
	// 	$('#input_3_32').val() // primary email
	// 	$('#input_3_34').val() // sec email
	// });

}( jQuery ) );

